// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0999240a","239":"cd1a30da","453":"036f2409","455":"f3f7a2cf"}[chunkId] + ".chunk.js";
};